import classnames from "classnames";
import styles from "@/styles/NoContentMessage.module.scss";
export default function NoContentMessage({ className, message, children }) {
  return (
    <div className={classnames(styles.container, className)}>
      {message && <p className={styles.message}>{message}</p>}
      {children && <>{children}</>}
    </div>
  );
}
